module.exports = __webpack_public_path__ + "img/Ma.Maritime.Quaywalls.Sheetpile-10m.Steel.a8f2d6e0.png";